export const INITIAL_VALUES = {
  date_start: '',
  date_finish: '',
  office: '',
  category_id: '',
  group_at: null,
  group_for: null,
};
